module.exports = __webpack_public_path__ + "static/img/CMMI3认证证书.59c2e04c.png";